import { useNavigate } from 'react-router-dom';
import NoSubjectsAllocatedImage from '../../assets/images/NoSubjectsAllocatedScreen.svg';
import ReloadIcon from '../../assets/images/ReloadIcon.svg';
const NoSubjectsAllocatedScreen = () => {
    const navigate = useNavigate();
    const handleRefresh = () => {
        // if (process.env.REACT_APP_INSTALLATION_MODE != 'desktop')
        // window.location.reload();
        navigate('/book-library');
    };
    return (
        <div className=" flex items-center justify-center mt-[5rem]">
            <div className=" flex items-center justify-center flex-col">
                <img
                    src={NoSubjectsAllocatedImage}
                    alt="No subjects allocated to you"
                />
                <p className=" text-3xl font-bold text-black mt-2">
                    No subjects allocated to you.
                </p>
                <p className="text-black font-light text-xl mt-2">
                    Please ask Your Academic Coordinator to allocate and then
                    please click on refresh.
                </p>
                <div
                    className="mt-4 px-6 py-2 flex justify-center space-x-2  bg-blue-500 text-white rounded-xl hover:bg-blue-600 hover:cursor-pointer"
                    onClick={handleRefresh}
                >
                    <img src={ReloadIcon} alt="Refresh Icon" />
                    <p>Refresh</p>
                </div>
            </div>
        </div>
    );
};

export default NoSubjectsAllocatedScreen;
